import { studentExerciseFetchInProgressInitState } from './InitState';
import { IEvent } from '../../../../../__core/Interfaces/IEvent';
import CURSE_INSTANCE_ACTIONS from '../../../Actions/ActionTypes';

export const studentExerciseFetchInProgressReducer = (
  state: boolean = studentExerciseFetchInProgressInitState,
  action: IEvent
): boolean => {
  switch (action.type) {
    case CURSE_INSTANCE_ACTIONS.FETCH_STUDENTS_EXERCISES_RESULT_START:
      return true;

    case CURSE_INSTANCE_ACTIONS.FETCH_STUDENTS_EXERCISES_RESULT_FINISH:
      return false;

    default:
      return state;
  }
};
